<H1> Analog In<app-loader [status]="loaderStatus"></app-loader></H1>
<mat-tab-group>
  <div *ngFor='let in of counter(4) ;let y = index'>
    <mat-tab label="AI {{ (y * 64) + 1}}- {{ (y+1) * 64}}A" >
      <mat-card class="analogout-card" *ngFor="let tile of tiles; let i = index" >
        <mat-list>
          <div *ngFor='let in of counter(32) ;let x = index'>
            <app-analogindetails [refNumber] = "(y*128)+ (i*32) + x" ></app-analogindetails>
          </div>
        </mat-list>
      </mat-card>
    </mat-tab>
  </div>
</mat-tab-group>



